<ion-header>
    <ion-toolbar>
        <!-- <ion-title>
            Add your result
        </ion-title> -->
    </ion-toolbar>
</ion-header>
<ion-content>
    <ion-card>
        <div class="image-container">
            <img src="{{ imageLink }}">
        </div>
        <ion-grid>
            <ion-row class="padding-sides">
                <ion-col col-3 class="centered">
                    {{ 'RESULT_CREATE_LABEL_TIME' | translate }}:
                </ion-col>
                <ion-col col-9>
                    <ion-datetime class="date-box" displayFormat="HH:mm:ss" placeholder="{{placeholder}}"
                        [(ngModel)]="model.time" (ionChange)="timeChanged()"></ion-datetime>
                </ion-col>
            </ion-row>
            <ion-row class="padding-sides">
                <ion-col col-7>
                    <button ion-button block (click)="onUploadPhoto()">Tracker Photo</button>
                </ion-col>
                <ion-col col-5>
                    <!-- [disabled]="!model.time || !model.photo"  -->
                    <button ion-button [disabled]="!model.time || !model.photo" block (click)="onSave()">{{'GLOBAL_SAVE'
                        | translate }}</button>
                </ion-col>
            </ion-row>
        </ion-grid>
    </ion-card>

</ion-content>